import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

// Hardcoded access codes for POC
const VALID_ACCESS_CODES = [
  'JBT-EVAL-7X9K2',
  'JBT-EVAL-M4P8Q',
  'JBT-EVAL-R2W6N',
  'JBT-EVAL-T5Y3H',
  'JBT-EVAL-V8D1F',
  'jbt#cecilio2026',
];

const SESSION_KEY = 'jbt-eval-access-granted';

function AccessGate({ children }) {
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (stored === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = accessCode.trim().toUpperCase();
    if (VALID_ACCESS_CODES.includes(trimmed)) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Código de acesso inválido. Tente novamente.');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 440 }}>
          <CardContent sx={{ p: 4 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mb: 3,
              }}
            >
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  backgroundColor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                }}
              >
                <LockOutlinedIcon sx={{ color: 'white', fontSize: 28 }} />
              </Box>
              <Typography variant="h5" component="h1" gutterBottom>
                JBT Eval
              </Typography>
              <Typography variant="body2" color="text.secondary" textAlign="center">
                Esta aplicação requer um código de acesso para continuar.
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Código de Acesso"
                variant="outlined"
                value={accessCode}
                onChange={(e) => {
                  setAccessCode(e.target.value);
                  setError('');
                }}
                placeholder="Ex: JBT-EVAL-XXXXX"
                autoFocus
                sx={{ mb: 2 }}
              />

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={!accessCode.trim()}
              >
                Acessar
              </Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}

export default AccessGate;
